import type { ActiveAnalysis } from "../api/useActiveAnalysesStream";
import type { QuantityIndex } from "../api/useQuantities";
import type { MetrologyOverrides } from "../api/useMetrologyOverrides";
import { inv } from "../lib/chiSquared";
import { isAnalysisQuantityValid } from "./metrology";
export default function computeSymptom(
  analysis: ActiveAnalysis,
  quantityIndex: QuantityIndex,
  _metrologyOverrides: MetrologyOverrides,
  observables: { quantityId: string; sigma: number }[],
  simulationOutputByQuantityId: Map<string /*quantityId*/, { offsetExpected: number | undefined }>,
): number {
  let count = 0;
  const norm = observables.reduce<number>((acc, obs) => {
    const quantityValue = analysis.quantityValues[obs.quantityId];
    if (quantityValue === undefined) return acc;
    const quantity = quantityIndex[obs.quantityId];
    if (quantity === undefined) return acc;
    const measured = quantityValue.measured;
    const simulated = quantityValue.simulated;
    if (simulated === null) return acc;
    const valid = isAnalysisQuantityValid(analysis, quantity);

    if (valid) {
      const simulationOutput = simulationOutputByQuantityId.get(obs.quantityId);
      const offset = simulationOutput?.offsetExpected ?? 0;
      const sigma = obs.sigma;

      count++;
      acc += Math.pow((simulated + offset - measured) / sigma, 2);
    }
    return acc;
  }, 0);

  return Math.sqrt(norm / inv(0.95, count)) * -1;
}
